/* B360 · LOCKED RELEASE (homepage teaser): countdown, public unlock, and EARLY-ACCESS unlock per banner.
   A visual reveal only. It is NOT authentication and protects nothing.

   Two separate systems:
   A. EARLY ACCESS (per banner): UNLOCK EARLY ACCESS. A logged-in customer unlocks that banner right here (no page change). A logged-out visitor
      goes through Shopify's real sign-up / sign-in (dedicated page, templates/customers + snippets/b360-early-access.liquid) and returns to this
      page, where the banner they chose unlocks by itself. Each banner has its own state (localStorage b360_spirit_unlocked / b360_ahd_unlocked).
   B. PUBLIC RELEASE: a fixed instant (25 October 2026 00:00 Dubai = 2026-10-24T20:00:00Z). At zero the timer stays at 00 and the reveal starts by itself (no button, no
      refresh); both banners unlock and the visit is remembered only as a visual state (localStorage b360_release_unlocked, never identity).
   A revealed banner becomes a link to its campaign page; nothing navigates automatically. */
(function () {
  'use strict';
  var root = document.querySelector('[data-b360-release]');
  if (!root || root.__b360ReleaseBound) return;            // one script, one set of listeners: a second copy of this file (re-render, duplicate tag) never binds again
  root.__b360ReleaseBound = true;

  var KEY = root.getAttribute('data-storage-key') || 'b360_release_unlocked';
  var at = Date.parse(root.getAttribute('data-release-at'));
  if (isNaN(at)) at = Number(root.getAttribute('data-fallback-ms'));
  var UNLOCK_MS = 2500;                                   // length of the unlock sequence (matches the CSS)
  var loggedIn = root.getAttribute('data-logged-in') === 'true';   // from Shopify (Liquid `customer`), only for the early-access convenience
  var cid = root.getAttribute('data-customer-id') || '';
  var TARGET = 'b360_early_access_target';               // sessionStorage: 'spirit' | 'ahd', the banner a visitor chose before signing in
  /* the campaign names live only here (never in the page markup, labels or alt text) and appear when a banner is unlocked */
  var NAMES = { spirit: { t: 'Spirit of the Nation', lang: '' }, ahd: { t: 'عهد الوفاء', lang: 'ar' } };

  var el = {
    d: root.querySelector('[data-b360-d]'), h: root.querySelector('[data-b360-h]'), m: root.querySelector('[data-b360-m]'), s: root.querySelector('[data-b360-s]'),
    btn: root.querySelector('[data-b360-unlock]'), status: root.querySelector('[data-b360-status]'),
    cards: [].slice.call(root.querySelectorAll('[data-b360-card]'))
  };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var offset = 0;                                         // server time minus this device's clock, so a wrong device clock cannot move the moment
  var timer = null, frozen = false;
  var now = function () { return Date.now() + offset; };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var state = function () { return root.getAttribute('data-state'); };
  var setState = function (s) { root.setAttribute('data-state', s); };
  var say = function (t) { if (el.status) el.status.textContent = t; };
  var released = function () { return now() >= at; };
  var keyOf = function (card) { return card.getAttribute('data-key'); };
  var cardState = function (card) { return card.getAttribute('data-card-state'); };
  var store = function (k) { try { window.localStorage.setItem(k, 'true'); } catch (e) {} };
  /* Authentication has priority over anything this browser remembers. Everything B360 keeps about early access (no cookies are ever set by this code) */
  function clearEarly(keepTarget) {
    try { var ls = window.localStorage; ls.removeItem('b360_spirit_unlocked'); ls.removeItem('b360_ahd_unlocked'); ls.removeItem('b360_early_cid'); } catch (e) {}
    if (!keepTarget) { try { window.sessionStorage.removeItem('b360_early_access_target'); window.sessionStorage.removeItem('b360_early_access_target_at'); } catch (e) {} }
  }
  var earlyKept = function () { try { return !!(window.localStorage.getItem('b360_spirit_unlocked') || window.localStorage.getItem('b360_ahd_unlocked')); } catch (e) { return false; } };

  /* ---------- countdown (public release) ---------- */
  function paint(ms) {
    var t = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(t / 86400), h = Math.floor((t % 86400) / 3600), m = Math.floor((t % 3600) / 60), s = t % 60;
    el.d.textContent = pad(d); el.h.textContent = pad(h); el.m.textContent = pad(m); el.s.textContent = pad(s);
  }
  function markReady() {
    paint(0); frozen = true;                              // frozen at 00 : 00 : 00 : 00
    root.setAttribute('data-over', '');                   // the countdown panel is removed (CSS); only the banners remain
    if (state() === 'locked') {
      setState('ready');
      say('Pre-order is open.');
      /* the moment has come: the reveal starts by itself (no button, no refresh), once; a visitor who arrives after the moment gets the same reveal once */
      window.setTimeout(unlockPublic, reduce ? 0 : 900);
    }
  }
  function tick() {
    if (frozen) return;
    var left = at - now();
    if (left <= 0) return markReady();
    paint(left);
    timer = window.setTimeout(tick, 1000 - (now() % 1000) + 5);   // wake just after the next second boundary
  }

  /* ---------- one banner ---------- */
  function showName(card) {
    var n = NAMES[keyOf(card)], slot = card.querySelector('[data-b360-name]');
    if (!n || !slot || slot.textContent) return;
    slot.textContent = n.t;
    if (n.lang) { slot.setAttribute('lang', n.lang); slot.setAttribute('dir', 'rtl'); }
  }
  function enableLink(card) {
    showName(card);
    var a = card.querySelector('[data-b360-link]'), href = card.getAttribute('data-after-unlock'), n = NAMES[keyOf(card)];
    if (!a || !href) return;
    a.setAttribute('href', href);
    a.removeAttribute('aria-hidden'); a.removeAttribute('tabindex');
    a.setAttribute('aria-label', (n ? n.t : 'Campaign') + ', enter');
    card.setAttribute('aria-label', (n ? n.t : 'Campaign') + ', open');
    var enter = card.querySelector('.b360-locked-card__enter'); if (enter) enter.removeAttribute('aria-hidden');
  }
  function finishCard(card, focus) {
    card.setAttribute('data-card-state', 'unlocked');
    enableLink(card);
    var n = NAMES[keyOf(card)];
    say((n ? n.t : 'The campaign') + ' is revealed.');
    if (focus) { var a = card.querySelector('[data-b360-link][href]'); if (a) { try { a.focus({ preventScroll: true }); } catch (e) {} } }
  }
  /* the ceremony for one banner: button away, shackle opens, gold light, lock withdraws, darkness lifts, the name settles, imagery at full brightness */
  function unlockCard(card, o) {
    o = o || {};
    if (cardState(card) !== 'locked') return false;
    showName(card);                                       // the real name is put in place (still invisible) so it can settle in as the frost clears
    card.setAttribute('data-card-state', 'unlocking');
    if (o.persist) store('b360_' + keyOf(card) + '_unlocked');
    say('Unlocking.');
    window.setTimeout(function () { finishCard(card, o.focus); }, UNLOCK_MS);
    return true;
  }
  function bringIntoView(card) {
    var r = card.getBoundingClientRect(), vh = window.innerHeight;
    if (r.top < 0 || r.bottom > vh * 0.92 || r.height * 0.5 + r.top > vh * 0.85) {
      try { card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); } catch (e) { card.scrollIntoView(); }
      return true;
    }
    return false;
  }

  /* ---------- public release: UNLOCK NOW unlocks both banners ---------- */
  function unlockPublic() {
    if (state() !== 'ready') return;
    var hadFocus = document.activeElement === el.btn;
    setState('unlocking');
    store(KEY);
    say('Unlocking.');
    el.cards.forEach(function (c) { unlockCard(c); });
    if (el.cards[0]) bringIntoView(el.cards[0]);
    window.setTimeout(function () {
      setState('unlocked'); el.btn.hidden = true;
      say('The campaigns are revealed.');
      if (hadFocus) { var a = root.querySelector('[data-b360-link][href]'); if (a) { try { a.focus({ preventScroll: true }); } catch (e) {} } }
    }, UNLOCK_MS);
  }

  /* ---------- early access ---------- */
  function readTarget() {
    var k = null;
    try { var v = new URLSearchParams(window.location.search).get('b360_early'); if (NAMES[v]) k = v; } catch (e) {}
    if (!k) { try { var s = window.sessionStorage.getItem(TARGET), t = Number(window.sessionStorage.getItem(TARGET + '_at')); if (NAMES[s] && Date.now() - t < 30 * 60 * 1000) k = s; } catch (e) {} }
    return k;
  }
  function clearTarget() {
    try { window.sessionStorage.removeItem(TARGET); window.sessionStorage.removeItem(TARGET + '_at'); } catch (e) {}
    try { var u = new URL(window.location.href); if (u.searchParams.has('b360_early')) { u.searchParams.delete('b360_early'); window.history.replaceState(window.history.state, '', u.pathname + (u.search || '') + u.hash); } } catch (e) {}
  }
  [].forEach.call(root.querySelectorAll('[data-b360-early]'), function (a) {
    a.addEventListener('click', function (e) {
      var key = a.getAttribute('data-key'), card = a.closest('[data-b360-card]');
      try { window.sessionStorage.setItem(TARGET, key); window.sessionStorage.setItem(TARGET + '_at', String(Date.now())); } catch (er) {}
      if (!loggedIn || !card) return;                    // logged out: the link goes to the dedicated sign-up page
      e.preventDefault();                                // logged in: unlock right here, no page change
      clearTarget();
      var kb = e.detail === 0;                           // activated from the keyboard
      bringIntoView(card);
      unlockCard(card, { persist: true, focus: kb });
    });
  });
  /* back from sign-up / sign-in: bring the chosen banner into view and unlock it automatically (no second click) */
  function resumeEarlyAccess() {
    var key = readTarget();
    if (!key || !loggedIn) return;
    var card = el.cards.filter(function (c) { return keyOf(c) === key; })[0];
    clearTarget();
    if (!card) return;
    var moved = bringIntoView(card);
    if (cardState(card) === 'locked') window.setTimeout(function () { unlockCard(card, { persist: true }); }, moved ? (reduce ? 200 : 900) : 300);
  }

  /* ---------- the campaign films (same logic as the private hub's spirit.js): attached near the screen, they play whether the banner is locked or not ---------- */
  function setUpFilms() {
    var phone = function () { try { return window.matchMedia('(max-width: 767px)').matches; } catch (e) { return false; } };
    var hasIO = 'IntersectionObserver' in window;
    [].forEach.call(root.querySelectorAll('[data-sp-media]'), function (w) {
      var old = w.querySelector('video'); if (!old) return;
      var v = old.cloneNode(true); old.parentNode.replaceChild(v, old);
      var attached = false, vis = false;
      v.controls = false; v.removeAttribute('controls'); v.muted = true; v.defaultMuted = true; v.setAttribute('muted', '');
      v.disablePictureInPicture = true; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
      v.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      v.addEventListener('playing', function () { w.classList.add('is-live'); });
      function attach() {
        if (attached || reduce) return;
        var src = phone() ? v.getAttribute('data-src-m') : v.getAttribute('data-src-d');
        if (!src) return;
        attached = true; v.preload = 'auto'; v.src = src;
      }
      function play() {
        if (reduce || !attached || !vis || document.hidden) return;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
      v.addEventListener('loadeddata', play); v.addEventListener('canplay', play);
      document.addEventListener('visibilitychange', function () { if (document.hidden) v.pause(); else play(); });
      if (!hasIO) { attach(); vis = true; play(); return; }
      new IntersectionObserver(function (es) { if (es[es.length - 1].isIntersecting) attach(); }, { rootMargin: '150% 0px 150% 0px' }).observe(w);
      new IntersectionObserver(function (es) { vis = es[es.length - 1].isIntersecting; if (vis) { attach(); play(); } else v.pause(); }, { threshold: 0.12 }).observe(w);
    });
  }
  /* the site's own video manager (an inline script in the page) takes every <video> it finds when the page has loaded and pauses all but the one most in
     view. These films must keep playing, locked or not, so they are swapped for fresh copies of themselves just AFTER that script has taken its list. */
  function initFilms() {
    var done = false;
    function go() { if (done) return; done = true; setUpFilms(); }
    document.addEventListener('DOMContentLoaded', go);
    window.addEventListener('load', go);
    if (document.readyState === 'complete') go();
  }

  /* ---------- NOTIFY ME: the customer's own details are registered for the release notification (one state PER edition banner) ---------- */
  var notifyMode = root.getAttribute('data-cta-mode') === 'notify';
  var nform = root.querySelector('.b360-notify-form'), nbusy = false, nTimer = 0;
  function cardOf(a) { return (a && a.closest && a.closest('.b360-locked-card')) || null; }
  /* "You Will Be Notified" is ONE state for the whole release: every Notify Me banner on the page changes together (busy / phone are only for the banner that was pressed) */
  function allCards() { return [].slice.call(root.querySelectorAll('.b360-locked-card')); }
  function setNState(a, v) {
    if (v === 'true') { allCards().forEach(function (c) { c.setAttribute('data-notified', 'true'); }); return; }
    var c = cardOf(a); if (!c) return; if (v) c.setAttribute('data-notified', v); else c.removeAttribute('data-notified');
  }
  function setNText(a, t) { allCards().forEach(function (c) { [].forEach.call(c.querySelectorAll('[data-b360-notified]'), function (n) { n.textContent = t; }); }); }
  function notifiedNow(a, fresh) {
    setNText(a, root.getAttribute('data-notified-text') || ''); setNState(a, 'true'); say(root.getAttribute('data-notified-text') || '');
    if (fresh) { var th = root.querySelector('[data-b360-thanks]'); if (th) th.hidden = false; }              // the thank-you line, only right after a signup
    if (!loggedIn) { try { window.localStorage.setItem('b360_notify_guest', String(Date.now())); } catch (e) {} }   // only a GUEST signup is remembered on the device; a signed-in customer's status is their own Shopify record, never kept here   // Shopify accepted the post: remembered on this device (a signed-in customer's own tags come from Shopify)
  }
  /* Shopify customer tags written by the NOTIFY ME post: B360_NOTIFY_ME on every signup (the "Notify Me" segment) + one tag per edition clicked (the b360_notify value). */
  var EDITION_TAG = { spirit: 'NOTIFY_SPIRIT', purity: 'NOTIFY_PURITY', shadow: 'NOTIFY_SHADOW', ahd: 'NOTIFY_AHD' };
  function tagsFor(key, phone) { var t = ['B360_NOTIFY_ME']; if (EDITION_TAG[key]) t.push(EDITION_TAG[key]); if (phone) t.push('NOTIFY_PHONE_' + phone.replace('+', '')); return t.join(','); }
  /* international mobile number (same rules as the NOTIFY ME page): Arabic-Indic digits accepted, 00 becomes +, a local UAE 05xxxxxxxx becomes +971 5xxxxxxxx,
     otherwise + and a country code (E.164: 8 to 15 digits, no leading 0). '' = not valid. */
  function normPhone(raw) {
    var s = String(raw || '').replace(/[٠-٩]/g, function (c) { return c.charCodeAt(0) - 0x0660; }).replace(/[۰-۹]/g, function (c) { return c.charCodeAt(0) - 0x06F0; });
    s = s.replace(/[\s\-().‎‏]/g, '');
    if (s.indexOf('00') === 0) s = '+' + s.slice(2);
    if (/^05\d{8}$/.test(s)) s = '+971' + s.slice(1);
    return /^\+[1-9]\d{7,14}$/.test(s) ? s : '';
  }
  var nIsAr = window.location.pathname.indexOf('/ar') === 0;
  function formPhone() { var i = nform && nform.querySelector('input[name="contact[phone]"]'); return i ? normPhone(i.value) : ''; }
  function setFormPhone(p) {
    var i = nform.querySelector('input[name="contact[phone]"]'); if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = 'contact[phone]'; nform.appendChild(i); }
    i.value = p;
  }
  function showPhonePrompt(a) {                           // a signed-in customer with no mobile number on their account is asked for it, right on the banner
    var c = cardOf(a); if (!c) return;
    setNState(a, 'phone');
    var box = c.querySelector('[data-b360-phone]'), inp = c.querySelector('[data-b360-phone-input]'), err = c.querySelector('[data-b360-phone-err]');
    if (box) box.hidden = false; if (err) { err.hidden = true; err.textContent = ''; }
    if (inp) { try { inp.focus(); } catch (e) {} }
  }
  function submitPhonePrompt(c) {
    var a = c && c.querySelector('[data-b360-notify]'), inp = c && c.querySelector('[data-b360-phone-input]'), err = c && c.querySelector('[data-b360-phone-err]'); if (!a || !inp) return;
    var p = normPhone(inp.value);
    if (!p) { if (err) { err.textContent = nIsAr ? 'يرجى إدخال رقم جوال صحيح مع رمز الدولة، مثل ‎+971 50 123 4567.' : 'Please enter a valid mobile number with the country code, e.g. +971 50 123 4567.'; err.hidden = false; } inp.focus(); return; }
    setFormPhone(p); postNotify(a);
  }
  function clearNotifyParam() {
    try { var u = new URL(window.location.href); if (u.searchParams.has('b360_notify')) { u.searchParams.delete('b360_notify'); window.history.replaceState(window.history.state, '', u.pathname + (u.search || '') + u.hash); } } catch (e) {}
  }
  /* ONE flow for the NOTIFY ME button (a single delegated listener below).
       1. Guest (no customer on the page, OR Shopify's /account says there is no session, OR a save answers "sign in"): straight to the NOTIFY ME page
          (button's data-guest-href = /account/register?b360_notify=<key>&checkout_url=..., name + email only, no account). The save is never called for a guest.
       2. Signed in: their own name + email (already in the hidden form) are posted with the edition's tag. The page's "signed in" flag is only a hint:
          Shopify's /account is asked at click time before any save. */
  function guestHref(a) { return (a && a.getAttribute('data-guest-href')) || ''; }
  function sendToSignup(a) { var h = guestHref(a); setNState(a, ''); if (h) window.location.assign(h); }
  function sessionState(done) {                           // done('in' | 'out' | 'unknown'): 'out' = Shopify redirects /account to sign-in, 'unknown' = could not ask
    if (!window.fetch) { done('unknown'); return; }
    fetch('/account', { method: 'GET', redirect: 'manual', credentials: 'same-origin', cache: 'no-store' }).then(function (r) {
      if (r.type === 'opaqueredirect' || (r.status >= 300 && r.status < 400) || r.status === 401 || r.status === 403) done('out');
      else done(r.ok ? 'in' : 'unknown');
    }, function () { done('unknown'); });
  }
  /* The save is a normal browser form post of Shopify's own customer form (name + email already in it, plus the edition tag), NOT a background request:
     Shopify's edge protection answers a background post to /contact with a "verifying your connection" challenge (HTTP 403), which can never succeed and was
     the cause of "We could not save that just now". A real post lets Shopify run that check if it wants to, saves the customer, and redirects back here with
     customer_posted=true, which is read below to show the confirmation. */
  function postNotify(a) {                                // only ever reached for a confirmed signed-in customer
    if (nbusy || !nform || !a) return;
    var key = (a.getAttribute('data-key') || '').replace(/[^a-z0-9_-]/gi, ''), tags = nform.querySelector('input[name="contact[tags]"]');
    if (tags) tags.value = tagsFor(key, formPhone());     // B360_NOTIFY_ME + the edition this click is for (+ the mobile number as a tag, in case the customer form ignores the phone field)
    nbusy = true; setNState(a, 'busy');
    try { window.sessionStorage.setItem('b360_notify_sent', key + '|' + Date.now()); } catch (e) {}   // Shopify sends the customer back to this page; this remembers which edition the post was for
    // submitted through the form's submit event (requestSubmit), so Shopify's own spam-protection script can add its CAPTCHA token; a plain form.submit() skips it ("Missing CAPTCHA token")
    if (nform.requestSubmit) nform.requestSubmit(); else nform.submit();
  }
  function notifyFlow(a) {
    if (!loggedIn || !nform) { sendToSignup(a); return; }  // guest: no save, no request, no message
    var c = cardOf(a); if (c && c.getAttribute('data-notified') === 'true') return;
    sessionState(function (s) {
      if (s === 'out') sendToSignup(a);
      else if (!formPhone()) showPhonePrompt(a);          // signed in, but no mobile number on the account: ask for it (the only thing asked)
      else postNotify(a);
    });
  }
  if (notifyMode) {
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-b360-notify]') : null;
      if (!a || !root.contains(a) || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault(); e.stopImmediatePropagation();     // nothing else on the page may act on this click
      notifyFlow(a);
    }, true);
    document.addEventListener('click', function (e) {       // the mobile-number prompt (signed-in customers without a number on file)
      var g = e.target && e.target.closest ? e.target.closest('[data-b360-phone-go]') : null; if (!g || !root.contains(g)) return;
      e.preventDefault(); submitPhonePrompt(cardOf(g));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var i = e.target && e.target.closest ? e.target.closest('[data-b360-phone-input]') : null; if (!i || !root.contains(i)) return;
      e.preventDefault(); submitPhonePrompt(cardOf(i));
    });
    /* The saved state decides what the buttons say.
         signed in -> ONLY that customer's own Shopify record (the B360_NOTIFY_ME tag, rendered by the server on every banner). Anything this browser remembers from a
                      guest signup or from another customer is erased now, so after logging out nobody inherits it.
         signed out -> the guest signup Shopify accepted on this device (never a signed-in customer's status). */
    function forgetNotifyFlags() { try { ['b360_notify_guest', 'b360_notified', 'b360_notified_spirit', 'b360_notified_ahd', 'b360_notified_purity', 'b360_notified_shadow'].forEach(function (k) { window.localStorage.removeItem(k); }); window.sessionStorage.removeItem('b360_notify_sent'); } catch (e) {} }
    /* the earlier versions kept a global "notified" flag in localStorage (b360_notified*): it survived logout and applied to whoever came next. It is never read again and is erased here, for everyone. */
    try { ['b360_notified', 'b360_notified_spirit', 'b360_notified_ahd', 'b360_notified_purity', 'b360_notified_shadow'].forEach(function (k) { window.localStorage.removeItem(k); }); } catch (e) {}
    if (loggedIn) forgetNotifyFlags();
    else {
      var had = ''; try { had = window.localStorage.getItem('b360_notify_guest') || ''; } catch (e) {}
      if (had) { setNText(null, root.getAttribute('data-notified-text') || ''); setNState(null, 'true'); }
    }
    document.addEventListener('click', function (e) {       // "Log out" pressed: forget at once, before the page changes
      var lo = e.target && e.target.closest ? e.target.closest('a[href*="/account/logout"]') : null; if (lo) forgetNotifyFlags();
    }, true);
    /* a page restored from the phone browser's back/forward cache (or a tab left open) can still show the state of someone who has since logged out or in:
       ask Shopify (its own /account) and, if the real session differs from what this page was built for, wipe and reload so the server renders the right state */
    var lastNCheck = Date.now();
    function recheckSession() {
      lastNCheck = Date.now();
      sessionState(function (s) {
        if ((loggedIn && s === 'out') || (!loggedIn && s === 'in')) { forgetNotifyFlags(); window.location.reload(); }
      });
    }
    window.addEventListener('pageshow', function (e) { if (e.persisted) recheckSession(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden && Date.now() - lastNCheck > 15000) recheckSession(); });
    var sentKey = '', wasPosted = false;                  // back from the post above: Shopify returns to the page it came from with customer_posted=true
    try {
      wasPosted = new URLSearchParams(window.location.search).get('customer_posted') === 'true';
      var sv = (window.sessionStorage.getItem('b360_notify_sent') || '').split('|');
      if (wasPosted && sv[0] && Date.now() - Number(sv[1] || 0) < 30 * 60 * 1000) sentKey = sv[0].replace(/[^a-z0-9_-]/gi, '');
      if (wasPosted) {
        window.sessionStorage.removeItem('b360_notify_sent');
        var cu = new URL(window.location.href); cu.searchParams.delete('customer_posted'); window.history.replaceState(window.history.state, '', cu.pathname + (cu.search || '') + cu.hash);
      }
    } catch (e) {}
    if (wasPosted) { var sa = (sentKey && root.querySelector('[data-b360-notify][data-key="' + sentKey + '"]')) || root.querySelector('[data-b360-notify]'); if (sa) notifiedNow(sa, true); }
    var backKey = ''; try { backKey = new URLSearchParams(window.location.search).get('b360_notify') || ''; } catch (e) {}
    if (backKey) {                                        // back from sign-in: a signed-in customer's click on that banner is completed
      clearNotifyParam();
      var ba = root.querySelector('[data-b360-notify][data-key="' + backKey.replace(/[^a-z0-9_-]/gi, '') + '"]'), bc = cardOf(ba);
      if (loggedIn && nform && ba && !sentKey && !(bc && bc.getAttribute('data-notified') === 'true')) window.setTimeout(function () {
        sessionState(function (s) { if (s !== 'out') postNotify(ba); });
      }, 400);
    }
  }

  /* ---------- the Shopify session decides (never this browser's memory) ---------- */
  if (!loggedIn) clearEarly();                            // signed out: forget every early unlock, the banners stay locked
  document.addEventListener('click', function (e) {       // the customer presses "log out": forget it at once, whatever happens next
    var a = e.target && e.target.closest ? e.target.closest('a[href*="/account/logout"]') : null;
    if (a) clearEarly();
  }, true);
  /* a page restored from the back/forward cache, or a tab left open and come back to, may still show the state of a customer who has since signed out
     (another tab, session expiry). Ask Shopify (its own /account page; no custom session): a redirect means signed out, so wipe and reload locked. */
  var checking = false, lastCheck = Date.now();
  function sessionStillValid() {
    if (!loggedIn || !earlyKept() || checking || !window.fetch) return;
    checking = true; lastCheck = Date.now();
    fetch('/account', { method: 'GET', redirect: 'manual', credentials: 'same-origin', cache: 'no-store' }).then(function (r) {
      checking = false;
      if (r.type === 'opaqueredirect' || (r.status >= 300 && r.status < 400)) { clearEarly(); window.location.reload(); }
    }, function () { checking = false; });
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) sessionStillValid(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden && Date.now() - lastCheck > 30000) sessionStillValid(); });

  /* once the countdown panel is gone (data-over) the first banner starts right below the fixed site header: its height is measured at the top of the page */
  function measureHeader() { var h = document.querySelector('m-header'); if (h && window.scrollY < 10) root.style.setProperty('--b360-hdr', Math.max(0, Math.round(h.getBoundingClientRect().bottom)) + 'px'); }
  measureHeader(); window.addEventListener('resize', measureHeader); window.addEventListener('load', measureHeader);

  /* ---------- start ---------- */
  initFilms();
  paint(Math.max(0, at - now()));
  el.cards.forEach(function (c) { if (cardState(c) === 'unlocked') enableLink(c); });     // banners the inline script restored from this browser
  window.requestAnimationFrame(function () { [].forEach.call(root.querySelectorAll('[data-instant]'), function (n) { n.removeAttribute('data-instant'); }); });
  if (state() === 'unlocked') {                           // the public release was already unlocked in this browser
    frozen = true; paint(0); el.btn.hidden = true;
  } else if (released()) {
    markReady();
  } else {
    tick();
  }
  el.btn.addEventListener('click', unlockPublic);
  resumeEarlyAccess();                                   // the script is deferred, so the page is already parsed; no need to wait for every image and video

  /* correct the device clock from the server's Date header (best effort; never blocks anything) */
  try {
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    var to = ctl ? window.setTimeout(function () { ctl.abort(); }, 4000) : null;
    fetch(window.location.pathname, { method: 'HEAD', cache: 'no-store', signal: ctl ? ctl.signal : undefined }).then(function (r) {
      if (to) window.clearTimeout(to);
      var d = Date.parse(r.headers.get('date') || '');
      if (!isNaN(d) && Math.abs(d - Date.now()) > 1500) {
        offset = d - Date.now();
        if (!frozen) { window.clearTimeout(timer); tick(); }
      }
    }, function () {});
  } catch (e) {}

  /* a visitor returning from another tab with a stale timer */
  document.addEventListener('visibilitychange', function () { if (!document.hidden && !frozen) { window.clearTimeout(timer); tick(); } });
})();
